import { z } from 'zod'

import { ConceptSchema } from '~/@entities/Concept'
import { LectureSchema } from '~/@entities/Lecture'
import { ProblemSchema } from '~/@entities/Problem'
import { ScoringResultSchema } from '~/@entities/Scoring'
import { WorksheetProblemSchema } from '~/@entities/Worksheet'

// 개념학습 단계가 내주는 강의 한 건. 강의 목록과 달리 커리큘럼·최근재생시각은 오지 않아 그 둘만 뺀다.
export const LearnedLectureSchema = z.object({
  lecture: LectureSchema.omit({ curriculum: true, latestPlayedAt: true }),
  studentLecture: z
    .object({
      studentId: z.string(),
      lectureId: z.number(),
      createDatetime: z.string().nullable(),
    })
    .nullable(),
})
export type LearnedLecture = z.infer<typeof LearnedLectureSchema>

/** 자기주도학습 개념학습 단계 — 이 학습지가 다루는 유형·강의와, 그 앞에 깔린 사전 유형·강의 */
export const ConceptLearningStepSchema = z.object({
  concepts: z.array(ConceptSchema),
  prevConcepts: z.array(ConceptSchema),
  lectures: z.array(LearnedLectureSchema),
  prevLectures: z.array(LearnedLectureSchema),
})
export type ConceptLearningStep = z.infer<typeof ConceptLearningStepSchema>

/***************** 오답학습 단계 *****************/

// 오답학습 단계의 문항 하나. 채점 기록의 studentWorksheetId 와 학습지 문항의 나머지 필드는 앱이 읽지 않아 받지 않는다.
export const WrongLearningScoringSchema = z.object({
  studentWorksheetScoring: z.object({
    worksheetProblemId: WorksheetProblemSchema.shape.id,
    result: ScoringResultSchema,
    userAnswer: z.string().nullable(),
    // 다중 셀 답의 미입력 칸은 null 원소다. 단답 문항은 null
    userAnswers: z.array(z.string().nullable()).nullable(),
    handwrittenNoteUrl: z.string().nullable(),
  }),
  worksheetProblem: z.object({
    orderingNumber: z.number(),
    tagTop: z.string().nullable(),
  }),
  problem: ProblemSchema,
})
export type WrongLearningScoring = z.infer<typeof WrongLearningScoringSchema>

/** 틀린 유형 하나의 오답학습 — 그 유형의 대표 문제와, 틀린 문항마다 이어 푸는 쌍둥이·유사 문항 */
export const WrongLearningStepSchema = z.object({
  wrongLearningKey: z.object({
    problem: ProblemSchema.nullable(),
    concept: ConceptSchema,
  }),
  prevScoringToPairOrSimilarScorings: z.array(
    z.object({
      prevScoring: WrongLearningScoringSchema,
      pairScorings: z.array(WrongLearningScoringSchema),
      similarScorings: z.array(WrongLearningScoringSchema),
    }),
  ),
})
export type WrongLearningStep = z.infer<typeof WrongLearningStepSchema>
